import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["timezone", "form", "submitButton", "downloadButton", "processingMessage"]

  connect() {
    this.setTimezone()
    this.handleKeyPress = this.handleKeyPress.bind(this)
    this.detectIcsContent = this.detectIcsContent.bind(this)
    document.addEventListener('keydown', this.handleKeyPress)

    const textarea = this.element.querySelector('textarea')
    if (textarea) {
      textarea.addEventListener('input', this.detectIcsContent)
    }
  }

  disconnect() {
    document.removeEventListener('keydown', this.handleKeyPress)
    const textarea = this.element.querySelector('textarea')
    if (textarea) {
      textarea.removeEventListener('input', this.detectIcsContent)
    }
  }

  setTimezone() {
    this.timezoneTarget.value = Intl.DateTimeFormat().resolvedOptions().timeZone
  }

  handleKeyPress(event) {
    if ((event.metaKey || event.ctrlKey) && event.key === 'Enter') {
      event.preventDefault()
      this.formTarget.requestSubmit()
    }
  }

  detectIcsContent() {
    const textarea = this.element.querySelector('textarea')
    if (!textarea) return

    const trimmed = textarea.value.trim()
    const isIcs = trimmed.startsWith('BEGIN:VCALENDAR') && trimmed.includes('END:VCALENDAR')

    if (isIcs) {
      this.submitButtonTarget.style.display = 'none'
      this.downloadButtonTarget.style.display = ''
      this.downloadButtonTarget.classList.remove('animate-pop-in')
      void this.downloadButtonTarget.offsetWidth
      this.downloadButtonTarget.classList.add('animate-pop-in')
      this.processingMessageTarget.innerHTML = "Looks like you already have a calendar file!<br>Download it directly."
    } else {
      this.submitButtonTarget.style.display = ''
      this.downloadButtonTarget.style.display = 'none'
      this.processingMessageTarget.textContent = "After processing, you'll be able to review the extracted event(s) and add them to your calendar"
    }
  }

  downloadIcs() {
    const textarea = this.element.querySelector('textarea')
    if (!textarea) return

    const content = textarea.value.trim()
    const blob = new Blob([content], { type: 'text/calendar;charset=utf-8' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = 'calendar.ics'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
  }
}
